import axios from "../Config/axios";

export default (options) => {
    return axios.request(options)
};